import { Box, TextField } from '@mui/material';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';

export interface TimeEditCellProps {
    onChange: (value: string) => void;
    field: string;
    value?: string;
}

export const TimeEditCell = ({ onChange, field, value, hideLabel }: TimeEditCellProps & { hideLabel?: boolean }) => {
    const [dateValue, setDateValue] = useState<Dayjs | null>(value ? dayjs(value) : null);

    useEffect(() => {
        value && setDateValue(dayjs(value));
    }, [value]);

    const handleChange = async (newValue: string | null) => {
        if (newValue === undefined) return;

        const date = dayjs(newValue);
        const isValidDate = date.isValid();
        if (isValidDate) {
            const formattedValue = date.toISOString();
            setDateValue(date);
            onChange(formattedValue);
        }
    };

    return (
        <Box sx={{ minWidth: 149 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker label={field} value={dateValue} onChange={handleChange} renderInput={(params) => <TextField {...params} />} />
            </LocalizationProvider>
        </Box>
    );
};
